export enum ETypAdresy {
    LEGALADDRESS = 'LEGALADDRESS',
    HEADQUARTERSADDRES = 'HEADQUARTERSADDRES',
    LEGALADDRESSALTERNATIVE = 'LEGALADDRESSALTERNATIVE',
    HQTRANSALTERNATIVE = 'HQTRANSALTERNATIVE'
}
